var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcArrowBack16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 13c-.442 0-.8-.35-.8-.783V4.783C7.2 4.35 7.558 4 8 4s.8.35.8.783v7.434A.79.79 0 0 1 8 13",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.234 8.534a.813.813 0 0 1 1.132 0L8 11.11l2.634-2.577a.813.813 0 0 1 1.132 0 .77.77 0 0 1 0 1.106l-3.2 3.13a.813.813 0 0 1-1.132 0l-3.2-3.13a.77.77 0 0 1 0-1.106",
  clipRule: "evenodd"
})));
export default SvgIcArrowBack16;